export default __webpack_public_path__ + "static/media/NSW_Accepted.a388ce96.png";